// extracted by mini-css-extract-plugin
export default {"root":"Skeleton_root__FWXNb","shimmer":"Skeleton_shimmer__xlyru"};